import React, { FC, Children } from 'react';

export interface ColorPassType {
  splitText: string;
  color?: string;
}

const ColorPass: FC<ColorPassType> = ({ children, splitText, color = 'black' }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const text = children.toString();
  const myRe = new RegExp(splitText, 'gi');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  let arrayIncludeValues = [];
  while (myRe.exec(text) !== null && splitText) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    arrayIncludeValues = [...arrayIncludeValues, text.slice(myRe.lastIndex - splitText.length, myRe.lastIndex)];
  }

  return (
    <span>
      {Children.toArray(
        text.split(myRe).map((val, i) => (
          <>
            <span>{val}</span>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            <span style={{ color }}>{arrayIncludeValues[i]}</span>
          </>
        )),
      )}
    </span>
  );
};

export default ColorPass;
